import React from 'react';
import { logError } from '../services/errorLogger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error?.message || 'Unbekannter Fehler' };
  }

  componentDidCatch(error, info) {
    logError(error?.message || String(error), {
      type: 'ErrorBoundary',
      stack: error?.stack,
      extra: { componentStack: info?.componentStack },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', height: '100vh', padding: '2rem', textAlign: 'center',
          fontFamily: 'sans-serif', background: '#f9fafb'
        }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚠️</div>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#111', marginBottom: '0.5rem' }}>
            Die App ist abgestürzt
          </h1>
          <p style={{ color: '#555', marginBottom: '1rem', maxWidth: '420px' }}>
            Ein unerwarteter Fehler ist aufgetreten. Der Fehler wurde automatisch gemeldet.
          </p>

          {/* Data safety notice */}
          <div style={{
            background: '#f0fdf4', border: '1px solid #86efac', borderRadius: '0.5rem',
            padding: '0.75rem 1.25rem', marginBottom: '1.5rem', maxWidth: '420px', textAlign: 'left'
          }}>
            <p style={{ color: '#15803d', fontWeight: 600, fontSize: '0.9rem', marginBottom: '0.25rem' }}>
              Deine Daten sind sicher
            </p>
            <p style={{ color: '#166534', fontSize: '0.82rem', lineHeight: 1.5 }}>
              Die App speichert automatisch alle 2 Sekunden. Deine Inspektionsdaten,
              Räume und Fotos sind lokal gesichert und werden nach dem Neu-Laden wiederhergestellt.
            </p>
          </div>

          <p style={{ color: '#aaa', fontSize: '0.78rem', marginBottom: '1.5rem', maxWidth: '400px', wordBreak: 'break-word' }}>
            Fehler: {this.state.errorMessage}
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '0.6rem 1.5rem', background: '#2563eb', color: '#fff',
              border: 'none', borderRadius: '0.5rem', cursor: 'pointer', fontSize: '1rem'
            }}
          >
            Seite neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
